import axios from 'axios';
import { adminClient as apolloClient } from '@/store/apollo';

import SetupGql from '@/store/graphql/system/queries/Setup.gql';
import TemplatesGql from '@/store/graphql/system/queries/Templates.gql';
import DocumentTemplatePartialPresetsGql from '@/store/graphql/system/queries/DocumentTemplatePartialPresets.gql';

export default {
    checkHealth: () => axios.get(`${process.env.VUE_APP_API_ENDPOINT}health-check`),
    fetchSetup: (cms = null) => {
        let variables = {};
        if (cms) variables.cms = parseInt(cms);
        return apolloClient.query({
            query: SetupGql,
            variables,
            fetchPolicy: 'network-only'
        });
    },
    fetchTemplates: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({ query: TemplatesGql })
                .then(({ data }) => resolve(data.CP_Templates))
                .catch(err => reject(err));
        }),
    fetchDocumentTemplatePartialPresets: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({ query: DocumentTemplatePartialPresetsGql })
                .then(({ data }) => resolve(data.DocumentTemplatePartialPresets))
                .catch(err => reject(err));
        }),
    setActiveCmsId(id) {
        return localStorage.setItem('active-cms-id', id);
    },
    getActiveCmsId() {
        return localStorage.getItem('active-cms-id') || null;
    },
    removeActiveCmsId() {
        localStorage.removeItem('active-cms-id');
    },
    setLocale(code) {
        return localStorage.setItem('locale', code);
    },
    getLocale() {
        return localStorage.getItem('locale') || 'de';
    },
    removeLocale() {
        localStorage.removeItem('locale');
    }
};
